"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


var _reselect = require('reselect');
var _authorization = require('shared/services/authorization');

 const selectCurrentUser = (state) => _optionalChain([state, 'optionalAccess', _ => _.currentUser]); exports.selectCurrentUser = selectCurrentUser
 const selectCurrentUserV2 = (state) => _optionalChain([state, 'optionalAccess', _2 => _2.dataV2, 'optionalAccess', _3 => _3.currentUser]); exports.selectCurrentUserV2 = selectCurrentUserV2
 const selectCurrentUserWithMentionSettings = _reselect.createSelector.call(void 0, 
  [exports.selectCurrentUser, exports.selectCurrentUserV2],
  (legacy, modern) => ({
    ...legacy,
    // GetMe and MeUpdate responses hydrate the V2 projection. Prefer each
    // defined V2 value so a later server update can replace a value cached by
    // the legacy login projection while retaining the legacy startup fallback.
    Suppress_Team_Mentions: _nullishCoalesce(_optionalChain([modern, 'optionalAccess', _4 => _4.Suppress_Team_Mentions]), () => ( _optionalChain([legacy, 'optionalAccess', _5 => _5.Suppress_Team_Mentions]))),
    Suppress_All_Mentions: _nullishCoalesce(_optionalChain([modern, 'optionalAccess', _6 => _6.Suppress_All_Mentions]), () => ( _optionalChain([legacy, 'optionalAccess', _7 => _7.Suppress_All_Mentions]))),
  }),
); exports.selectCurrentUserWithMentionSettings = selectCurrentUserWithMentionSettings
 const selectCurrentUserKey = (state) => {
  const user = exports.selectCurrentUserV2.call(void 0, state)
  return _optionalChain([user, 'optionalAccess', _8 => _8.UserKey])
}; exports.selectCurrentUserKey = selectCurrentUserKey

 const selectIsCurrentUserActive = (state) => state.activity.active; exports.selectIsCurrentUserActive = selectIsCurrentUserActive

 const selectIsUserLoggedIn = (state) => {
  const u = exports.selectCurrentUserV2.call(void 0, state)
  return !!(u && u.UserKey)
}; exports.selectIsUserLoggedIn = selectIsUserLoggedIn

 const selectAmISuperUser = _reselect.createSelector.call(void 0, 
  exports.selectCurrentUser,
  me => Object.values(_optionalChain([me, 'optionalAccess', _9 => _9.Relationships]) || {}).some(o => _authorization.superUserOrgKeys[o.OrgKey]),
); exports.selectAmISuperUser = selectAmISuperUser
